/** Validação compartilhada — espelha api-web-stories/app/services/cadastro_survey.py */

const FAKE_NAMES = new Set([
  "indefinido", "undefined", "null", "n/a", "na", "-",
  "anonimo", "anônimo", "usuário", "usuario", "user", "usuaria",
]);

export function isRealName(value) {
  const raw = String(value || "").trim();
  if (raw.length < 2) return false;
  if (FAKE_NAMES.has(raw.toLowerCase())) return false;
  return /[a-zA-ZÀ-ÿ]{2,}/.test(raw);
}

export function phoneDigits(value) {
  return String(value || "").replace(/\D/g, "");
}

export function isColetaComplete(u) {
  if (!u) return false;
  const prefs = u.preferences || {};
  const brands = prefs.selected_brands || prefs.favorite_brands || [];
  return (
    isRealName(u.name) &&
    phoneDigits(u.phone).length >= 8 &&
    Boolean(u.gender) &&
    Boolean(String(prefs.produto_promo || "").trim()) &&
    Boolean(prefs.selected_option) &&
    brands.length > 0
  );
}

export function isIndefinidoUser(u) {
  if (!u) return true;
  const name = String(u.name || "").trim().toLowerCase();
  return !name || name === "indefinido" || FAKE_NAMES.has(name);
}

export function coletaMissingFields(u) {
  if (!u) return ["Perfil"];
  const missing = [];
  const prefs = u.preferences || {};
  const brands = prefs.selected_brands || prefs.favorite_brands || [];

  if (!isRealName(u.name)) missing.push("Nome");
  if (phoneDigits(u.phone).length < 8) missing.push("Telefone");
  if (!u.gender) missing.push("Gênero");
  if (!String(prefs.produto_promo || "").trim()) missing.push("Produto promo");
  if (!prefs.selected_option) missing.push("Bolsa de griffe");
  if (brands.length === 0) missing.push("Marcas");

  return missing;
}

export function needsColetaModal(u) {
  if (!u) return false;
  const prefs = u.preferences || {};
  return !isColetaComplete(u) || prefs.force_coleta_modal === true;
}

/** Monta telefone como no submit do modal de cadastro. */
export function formatCadastroPhone(countryCode, ddd, phoneNumber, usPhone) {
  const cc = String(countryCode || "").trim();
  const d = String(ddd || "").replace(/\D/g, "");
  const n = String(phoneNumber || "").replace(/\D/g, "");
  return usPhone ? `${cc}${n}` : `${cc}${d}${n}`;
}

export function isCadastroPhoneValid(countryCode, ddd, phoneNumber, usPhone) {
  if (!String(countryCode || "").trim()) return false;
  const d = String(ddd || "").replace(/\D/g, "");
  const n = String(phoneNumber || "").replace(/\D/g, "");
  const digits = phoneDigits(formatCadastroPhone(countryCode, ddd, phoneNumber, usPhone));
  if (digits.length < 10) return false;
  if (!usPhone && d.length !== 2) return false;
  return n.length >= 8;
}

/**
 * Campos faltando no formulário (UI) — cada item tem key para scroll/foco.
 */
export function cadastroFormMissing({
  name,
  countryCode,
  ddd,
  phoneNumber,
  usPhone,
  gender,
  selectedBrands,
  selectedOption,
  produtoPromo,
  legacyLead,
  insta,
  date,
}) {
  const missing = [];
  if (!isRealName(name)) {
    missing.push({ key: "name", label: "Nome completo" });
  }
  if (!isCadastroPhoneValid(countryCode, ddd, phoneNumber, usPhone)) {
    missing.push({ key: "phone", label: "WhatsApp com DDD" });
  }
  if (!selectedBrands?.length) {
    missing.push({ key: "brands", label: "Pelo menos 1 marca" });
  }
  if (!selectedOption) {
    missing.push({ key: "bolsa", label: "Bolsa de griffe" });
  }
  if (!gender) {
    missing.push({ key: "gender", label: "Gênero" });
  }
  if (!String(produtoPromo || "").trim()) {
    missing.push({ key: "produto_promo", label: "O que quer na promo" });
  }
  if (legacyLead) {
    if (!String(insta || "").trim()) {
      missing.push({ key: "insta", label: "Instagram (@)" });
    }
    if ((selectedBrands?.length || 0) < 3) {
      missing.push({ key: "brands", label: "Pelo menos 3 marcas" });
    }
    if (!String(date || "").trim()) {
      missing.push({ key: "birthday", label: "Data de nascimento" });
    }
  }
  return missing;
}

export function isCadastroFormComplete(fields) {
  return cadastroFormMissing(fields).length === 0;
}
